export const CREDIT_CARD_METHOD = 'braintree'
export const PAYPAL_METHOD = 'paypalMethod'
export const PRZELEWY24_METHOD = 'przelewy24'
export const INVOICE_METHOD = 'invoice'
export const PAYPAL = 'paypal'
